import { render, staticRenderFns } from "./DesktopMasthead.vue?vue&type=template&id=489da5d3&"
import script from "./DesktopMasthead.vue?vue&type=script&lang=js&"
export * from "./DesktopMasthead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports